import { defineComponent, h } from 'vue';
import { QList, QItem, QItemSection, QItemLabel } from 'quasar';
import utils from '../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'select-list',
    mixins: [BaseComponent],
    components: { QList, QItem, QItemSection, QItemLabel },
    data: function () {
        return {
            source: [],
            sourceurl: null,
            sourceraw: null,
            selectedItem: -1,

            selectedvalueexpr: null,
        }
    },
    created() {
        switch (this.controlData.SourceType)
        {
            case 'Raw':
                this.sourceraw = utils.compileObject(this, this.controlData.Source);
                break;

            case 'URL':
                this.sourceurl = utils.compile(this, this.controlData.SourceURL);
                break;
        }

        if (this.controlData.SelectedValue) {
            this.selectedvalueexpr = utils.compile(this, this.controlData.SelectedValue);
            this.selectedItem = this.selectedValue;
        }
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        selectedValue: function () {
            const fields = this.controlData.FieldMappings;

            console.log(`SelectList.selectedValue source: ${JSON.stringify(this.source)}`);

            if (this.selectedvalueexpr)
                console.log(`SelectList.selectedValue computed expression: ${this.selectedvalueexpr.code}`);

            let value;
            if (this.selectedvalueexpr)
                value = utils.evaluate(this.selectedvalueexpr, this);

            console.log(`SelectList.selectedValue computed value: ${value}`);

            console.log(`SelectList.selectedValue computed fields.Value: ${fields.Value}`);

            const idx = this.source.findIndex(s => s[fields.Value] == value);

            console.log(`SelectList.selectedValue computed value: ${idx}`);

            return idx;
        }
    },
    methods: {
        async preRenderComplete() {
            await this.Refresh();
            this.finishRenderHandler(this);
        },
        async Refresh() {
            if (this.sourceurl) {
                this.source = await utils.api.get(utils.evaluate(this.sourceurl, this));
            }
            else if (this.sourceraw) {
                this.source = utils.evaluateObject(this.sourceraw, this);
            }

            // Apply initial selection after source is loaded.
            if (this.selectedvalueexpr) {
                this.selectedItem = this.selectedValue;
            }
        },
        selectItem(e, index, item) {
            const fields = this.controlData.FieldMappings;
            this.selectedItem = index;

            this.utils.executeAndCompileAllActions(this.controlData.Actions, { Value: item[fields.Value], SourceItem: item, SourceIndex: index }, this);
        },
    },
    props: {
    },
    render() {
        if(!this.todisplay)
            return null;
        
        try {
            const fields = this.controlData.FieldMappings;
            const items = [];
            const source = this.source || [];
    
            for (let i = 0; i < source.length; i++) {
                const item = source[i];
                const isSelected = this.selectedItem === i;
                const itemStyle = isSelected
                    ? { background: '#e8f0fe', borderRadius: '8px', margin: '4px' }
                    : { background: 'transparent', borderRadius: '8px', margin: '4px' };
    
                // 2. Dynamically set the text color class based on selection
                const titleClass = isSelected 
                    ? "text-weight-medium text-primary" 
                    : "text-weight-medium text-dark";


                items.push(
                    <QItem
                        key={i}
                        clickable
                        active={isSelected}
                        class="q-mx-xs q-my-sm q-px-sm q-py-xs"
                        style={itemStyle}
                        onClick={(e) => this.selectItem(e, i, item)}>

                        <QItemSection class="q-my-md">
                            {/* Apply the dynamic titleClass here */}
                            <QItemLabel class={titleClass}>{item[fields.Title]}</QItemLabel>
                            <QItemLabel caption class="text-grey-9">{item[fields.Description]}</QItemLabel>
                        </QItemSection>
                    </QItem>
                );
            }
    
            const style = {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };

            let customClasses = "";
            if (this.styleHints && this.styleHints.CustomClasses) {
                customClasses = utils.resolveCustomClasses(this.styleHints, this);
            }
    
            return (
                <div
                    v-show={this.isvisible}
                    class={{ 'c-SelectList': true,
                    [`c-name-${this.name || 'unnamed'}`]: true,
                    [`${customClasses}`]: true }}
                    style={style}>
                    <QList dense class="q-py-xs">
                        {items}
                    </QList>
                </div>
            );
        }
        catch(e){
            utils.error('SelectList Render failed', e);
            return <div>SelectList Failed to Render {e}</div>;
        }
    }
});